var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import LowPriceArea from './low_price_area';
import ConditionArea from './condition_area';
import Loading2 from "../../main/loading2";
var SummaryInfoBasic = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var marketList = useSelector(function (state) { return state.product.marketList; });
    var marketListLoaded = useSelector(function (state) { return state.product.marketListLoaded; });
    var priceInfo = useSelector(function (state) { return state.product.priceInfo; });
    var priceDataNumber = useSelector(function (state) { return state.product.priceStateNumber; });
    var priceStateText = useSelector(function (state) { return state.product.priceStateText; });
    return (React.createElement(Style, null,
        !marketListLoaded ? React.createElement(Loading2, null) :
            (
            // (priceInfo &&
            React.createElement(LowPriceArea, { priceInfo: priceInfo, item: item })
            // )
            ),
        !marketListLoaded ? React.createElement(Loading2, null) :
            (marketList && (priceStateText === "price")) &&
                React.createElement(ConditionArea, { marketList: marketList, priceInfo: priceInfo })));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 430px;\n    margin: 0 0 0 20px;\n    flex-direction: column;\n    justify-content: space-between\n    border: 1px solid red\n"], ["\n    display: flex;\n    width: 430px;\n    margin: 0 0 0 20px;\n    flex-direction: column;\n    justify-content: space-between\n    border: 1px solid red\n"])));
export default SummaryInfoBasic;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/summary_info/basic/index.tsx
// module id = 201
// module chunks = 0